// 01/10/2019 PF: This is only for modals
const handleAjaxResponse = function(data) {
  if (data.success) {
    if (data.shard) {
      $(data.html)
        .appendTo($(data.shard))
        .trigger('bless')
    }

    if (data.replacements) {
      $.each(data.replacements, function(index, value) {
        var $html = $(value.html),
          target = value.selector

        $html.replaceAll(target).trigger('bless')
      })
    }

    $('#briq-modal').modal('hide')
  }
}

export default handleAjaxResponse
